import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const cupcakeImg = "https://i.imgur.com/y7P3O0U.png";

const questionTemplates = [
  (rate, time, bakers) => ({
    text: `${bakers} baker${bakers > 1 ? 's' : ''} can bake ${rate} cupcakes/hour. How many in ${time} hour${time > 1 ? 's' : ''}?`,
    answer: rate * time * bakers,
  }),
  (rate, time, bakers) => ({
    text: `Each of ${bakers} bakers bakes ${rate} cupcakes per hour. Total after ${time} hour${time > 1 ? 's' : ''}?`,
    answer: rate * time * bakers,
  }),
  (rate, time, bakers) => ({
    text: `You have ${bakers} baker${bakers > 1 ? 's' : ''}, each makes ${rate} cupcakes/hour. Total in ${time} hour${time > 1 ? 's' : ''}?`,
    answer: rate * time * bakers,
  }),
];

const CupcakeChallenge = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState(0);
  const [userInput, setUserInput] = useState('');
  const [feedback, setFeedback] = useState('');
  const [cupcakes, setCupcakes] = useState([]);

  const generateQuestion = () => {
    const rate = Math.floor(Math.random() * 6) + 4;
    const time = Math.floor(Math.random() * 5) + 1;
    const bakers = Math.floor(Math.random() * 3) + 1;
    const template = questionTemplates[Math.floor(Math.random() * questionTemplates.length)];
    const generated = template(rate, time, bakers);
    setQuestion(generated.text);
    setAnswer(generated.answer);
    setUserInput('');
    setFeedback('');
    setCupcakes([]);
  };

  const checkAnswer = () => {
    const userVal = parseInt(userInput, 10);
    if (userVal === answer) {
      setFeedback("🎉 YAY! You got it right!");
       const responsedata = ConstructorEventUpdateSQLStatus();
                      console.log("Event completed", responsedata);
      const cupcakeIcons = Array.from({ length: Math.min(answer, 20) }, (_, i) => i);
      setCupcakes(cupcakeIcons);

    } else {
      setFeedback(`❌ Oops! The correct answer is ${answer} cupcakes.`);
      setCupcakes([]);
    }
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(#ffe0f0, #fff3f7)',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 0,
      padding: 0,
    },
    header: {
      width: '100%',
      background: '#ff69b4',
      padding: '20px',
      fontSize: '28px',
      fontWeight: 'bold',
      color: 'white',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
      textAlign: 'center',
    },
    main: {
      flex: 1,
      width: '100%',
      maxWidth: '800px',
      padding: '30px',
      textAlign: 'center',
    },
    scenario: {
      background: '#fff0f5',
      border: '3px dashed #ff69b4',
      borderRadius: '20px',
      padding: '25px',
      fontSize: '22px',
      marginBottom: '25px',
    },
    input: {
      fontSize: '1rem',
      padding: '10px',
      borderRadius: 6,
      border: '2px solid #f9a825',
      textAlign: 'center',
      width: '180px',
      margin: '15px auto',
      display: 'block',
    },
    button: {
      background: '#ff69b4',
      color: 'white',
      border: 'none',
      padding: '12px 24px',
      fontSize: '20px',
      borderRadius: '12px',
      cursor: 'pointer',
      margin: '10px',
    },
    feedback: {
      fontSize: '22px',
      marginTop: '20px',
      minHeight: '30px',
      color: feedback.includes('YAY') ? 'green' : 'red',
    },
    cupcakes: {
      marginTop: '15px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    cupcakeImg: {
      width: '40px',
      margin: '3px',
    },
    footer: {
      padding: '15px',
      background: '#ffe6f0',
      fontSize: '14px',
      width: '100%',
      textAlign: 'center',
      color: '#777',
    },
  };

  return (
    <div style={styles.body}>
      <style>{`
        @media (max-width: 600px) {
          .scenario-text {
            font-size: 18px !important;
          }
          input {
            width: 80% !important;
            font-size: 1rem;
          }
          button {
            width: 90% !important;
            font-size: 1rem !important;
          }
          img {
            width: 30px !important;
          }
        }
      `}</style>
      <header style={styles.header}>🧁 Cupcake Bakers Challenge</header>
      <main style={styles.main}>
        <div className="scenario-text" style={styles.scenario}>{question}</div>
        <input
          type="number"
          style={styles.input}
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder="Enter number"
        />
        <button style={styles.button} onClick={checkAnswer}>✅ Check Answer</button>
        <button style={styles.button} onClick={generateQuestion}>🔄 New Question</button>
        <div style={styles.feedback}>{feedback}</div>
        
      </main>
      {/* <footer style={styles.footer}>Made with ❤️ for little bakers!</footer> */}
    </div>
  );
};

export default CupcakeChallenge;
